import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import Login from '@/views/user/login'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '*',
    redirect: '/'},//访问意料之外的路由时重定向到/personal
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊（医生端）'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/navigation/dynamicEcg',
    component: (resolve) => require(['@/views/navigation/dynamicEcg/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(动态心电检查)'
    }
  },
  {
    path: '/navigation/drugDelivery',
    component: (resolve) => require(['@/views/navigation/drug/drugDelivery'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '配送'
    }
  },
  {
    path: '/navigation/patient/list',
    component: (resolve) => require(['@/views/navigation/patient/listIndex'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(我的患者)'
    }
  },
  {
    path: '/navigation/patient/detailOfflineReport',
    component: (resolve) => require(['@/views/navigation/patient/listOfflineReportIndex'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(我的患者)'
    }
  },
  {
    path: '/navigation/activity',
    component: (resolve) => require(['@/views/navigation/activity/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(活动管理)'
    }
  },
  {
    name:"activityDetail",
    path: '/navigation/activity/detail',
    component: (resolve) => require(['@/views/navigation/activity/detail'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(活动详情）'
    }
  },
  {
    name:"patientDetail",
    path: '/navigation/patient/detail',
    component: (resolve) => require(['@/views/navigation/patient/detailIndex'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(患者详情）'
    }
  },
  {
    path: '/navigation/examineList',
    component: (resolve) => require(['@/views/navigation/examine/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(检查记录）'
    }
  },
  {
    path: '/navigation/print',
    component: (resolve) => require(['@/views/navigation/print/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '检查任务-打印'
    }
  },
  {
    path: '/callback',
    component: (resolve) => require(['@/views/callback'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '京东回调页面'
    }
  },
  {
    path: '/navigation/extreme',
    component: (resolve) => require(['@/views/navigation/extreme/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(极速问诊)'
    }
  },
  {
    path: '/navigation/chronic',
    component: (resolve) => require(['@/views/navigation/chronic/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(慢病管理)'
    }
  },
  {
    path: '/navigation/drugExamine',
    component: (resolve) => require(['@/views/navigation/drug/drugExamine'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '院内处方审核'
    }
  },
  {
    path: '/navigation/outsideDrugExamine',
    component: (resolve) => require(['@/views/navigation/drug/outsideDrugExamine'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '院外处方审核'
    }
  },
  {
    path: '/navigation/drugCopy',
    component: (resolve) => require(['@/views/navigation/drug/drugCopy'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '药品复制'
    }
  },
  {
    path: '/navigation/drugMaintain',
    component: (resolve) => require(['@/views/navigation/drug/drugMaintain'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '药品管理'
    }
  },
  {
    path: '/navigation/HealthScience',
    component: (resolve) => require(['@/views/navigation/HealthScience/index'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(健康科普)'
    }
  },
  {
    path: '/navigation/HealthGet',
    component: (resolve) => require(['@/views/navigation/HealthScience/get'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: true,
      title: '白医云·诊(健康科普)'
    }
  },
  {
    path: '/navigation/store',
    component: (resolve) => require(['@/views/test/store'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: false,
      title: '白医云·诊(VUEX)'
    }
  },
    {
    path: '/navigation/jdcheck',
    component: (resolve) => require(['@/views/navigation/jdcheck'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: false,
      title: '京东审方'
    }
  }
  /*{
    path: '/navigation/testSwiper',
    component: (resolve) => require(['@/views/components/swiper/showImages'], resolve),
    hidden: true,
    meta: {
      keepAlive: false,
      login: false,
      title: '白医云·诊(图片查看)'
    }
  },*/
]


export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js